import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-pwa-studio/commerce-pwa-studio/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Functions`}</p>
    <dl>
      <dt><a href="#useCouponCode">useCouponCode(props)</a> ⇒ <inlineCode><a href="#CouponCodeTalonProps">CouponCodeTalonProps</a></inlineCode></dt>
      <dd>
        <p>{`This talon contains the logic for a coupon code form component.
It performs effects and returns props data for rendering the component.`}</p>
        <p>{`This talon performs the following effects:`}</p>
        <ul>
          <li parentName="ul">{`Fetch all coupons associated with the cart`}</li>
          <li parentName="ul">{`Manage the updating state of the cart while a coupon is being applied or removed`}</li>
        </ul>
      </dd>
      <dt><a href="#useShippingForm">useShippingForm(props)</a> ⇒ <inlineCode><a href="#ShippingFormTalonProps">ShippingFormTalonProps</a></inlineCode></dt>
      <dd>
        <p>{`Contains logic for a shipping form component.
It performs effects and returns props data related to rendering a shipping address form.`}</p>
        <p>{`This talon performs the following effects:`}</p>
        <ul>
          <li parentName="ul">{`Manage the updating state of the cart while the mutation for setting the shipping address is in flight`}</li>
        </ul>
      </dd>
      <dt><a href="#useShippingMethods">useShippingMethods(props)</a> ⇒ <inlineCode><a href="#ShippingMethodsTalonProps">ShippingMethodsTalonProps</a></inlineCode></dt>
      <dd>
        <p>{`Contains logic for a shipping method selector component.
It performs effect and returns props data used to render that component.`}</p>
        <p>{`This talon performs the following effects:`}</p>
        <ul>
          <li parentName="ul">{`Set the shipping form visibility value based on the shipping methods associated with the cart`}</li>
        </ul>
      </dd>
      <dt><a href="#useShippingRadios">useShippingRadios(props)</a> ⇒ <inlineCode><a href="#ShippingRadiosTalonProps">ShippingRadiosTalonProps</a></inlineCode></dt>
      <dd>
        <p>{`Contains logic for a component that renders a radio selector for shipping.
It performs effects and returns props data used for rendering that component.`}</p>
        <p>{`This talon performs the following effects:`}</p>
        <ul>
          <li parentName="ul">{`Sets the value of the shipping method to a default value if there is no current method selected`}</li>
          <li parentName="ul">{`Manage the updating state of the cart while a shipping method is being applied`}</li>
        </ul>
      </dd>
    </dl>
    <p>{`Typedefs`}</p>
    <dl>
      <dt><a href="#CouponCodeMutations">CouponCodeMutations</a> : <inlineCode>Object</inlineCode></dt>
      <dd>
        <p>{`GraphQL mutations for a cart's coupon code.
This is a type used by the `}<a parentName="p" {...{
            "href": "#useCouponCode"
          }}>{`useCouponCode`}</a>{` talon.`}</p>
      </dd>
      <dt><a href="#CouponCodeQueries">CouponCodeQueries</a> : <inlineCode>Object</inlineCode></dt>
      <dd>
        <p>{`GraphQL queries for a cart's coupon code.
This is a type used by the `}<a parentName="p" {...{
            "href": "#useCouponCode"
          }}>{`useCouponCode`}</a>{` talon.`}</p>
      </dd>
      <dt><a href="#CouponCodeTalonProps">CouponCodeTalonProps</a> : <inlineCode>Object</inlineCode></dt>
      <dd>
        <p>{`Object type returned by the `}<a parentName="p" {...{
            "href": "#useCouponCode"
          }}>{`useCouponCode`}</a>{` talon.
It provides props data to use when rendering a coupon code component.`}</p>
      </dd>
      <dt><a href="#SelectShippingFields">SelectShippingFields</a> : <inlineCode>Object</inlineCode></dt>
      <dd>
        <p>{`Values for the select input fields on the shipping form.
This is a prop used by the `}<a parentName="p" {...{
            "href": "#useShippingForm"
          }}>{`useShippingForm`}</a>{` talon.`}</p>
      </dd>
      <dt><a href="#ShippingFormMutations">ShippingFormMutations</a> : <inlineCode>Object</inlineCode></dt>
      <dd>
        <p>{`GraphQL mutations for the shipping form.
This is a type used by the `}<a parentName="p" {...{
            "href": "#useShippingForm"
          }}>{`useShippingForm`}</a>{` talon.`}</p>
      </dd>
      <dt><a href="#ShippingFormQueries">ShippingFormQueries</a> : <inlineCode>Object</inlineCode></dt>
      <dd>
        <p>{`GraphQL queries for the shipping form.
This is a type used by the `}<a parentName="p" {...{
            "href": "#useShippingForm"
          }}>{`useShippingForm`}</a>{` talon.`}</p>
      </dd>
      <dt><a href="#ShippingFormTalonProps">ShippingFormTalonProps</a> : <inlineCode>Object</inlineCode></dt>
      <dd>
        <p>{`Object type returned by the `}<a parentName="p" {...{
            "href": "#useShippingForm"
          }}>{`useShippingForm`}</a>{` talon.
It provides props data to use when rendering a shipping form component.`}</p>
      </dd>
      <dt><a href="#ShippingMethodsQueries">ShippingMethodsQueries</a> : <inlineCode>Object</inlineCode></dt>
      <dd>
        <p>{`GraphQL queries for shipping methods.
This is a type used in the `}<a parentName="p" {...{
            "href": "#useShippingMethods"
          }}>{`useShippingMethods`}</a>{` talon.`}</p>
      </dd>
      <dt><a href="#ShippingMethodsTalonProps">ShippingMethodsTalonProps</a> : <inlineCode>Object</inlineCode></dt>
      <dd>
        <p>{`Object type returned by the `}<a parentName="p" {...{
            "href": "#useShippingMethods"
          }}>{`useShippingMethods`}</a>{` talon.
It provides prop data to use when rendering shipping methods.`}</p>
      </dd>
      <dt><a href="#ShippingRadiosMutations">ShippingRadiosMutations</a> : <inlineCode>Object</inlineCode></dt>
      <dd>
        <p>{`GraphQL mutations for a shipping radio selector component.
This is a type used by the `}<a parentName="p" {...{
            "href": "#useShippingRadios"
          }}>{`useShippingRadios`}</a>{` talon.`}</p>
      </dd>
      <dt><a href="#ShippingRadiosTalonProps">ShippingRadiosTalonProps</a> : <inlineCode>Object</inlineCode></dt>
      <dd>
        <p>{`Object type returned by the `}<a parentName="p" {...{
            "href": "#useShippingRadios"
          }}>{`useShippingRadios`}</a>{` talon.
It provides data to use when rendering a radio selector for shipping methods.`}</p>
      </dd>
    </dl>
    <p>{`This talon contains the logic for a coupon code form component.
It performs effects and returns props data for rendering the component.`}</p>
    <p>{`This talon performs the following effects:`}</p>
    <ul>
      <li parentName="ul">{`Fetch all coupons associated with the cart`}</li>
      <li parentName="ul">{`Manage the updating state of the cart while a coupon is being applied or removed`}</li>
    </ul>
    <p><strong parentName="p">{`Returns:`}</strong>{`
`}<strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`props`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`props.setIsCartUpdating`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Callback function for setting the update state for the cart.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`props.mutations`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#CouponCodeMutations"
            }}><inlineCode parentName="a">{`CouponCodeMutations`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`GraphQL mutations for a cart's coupon code.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`props.queries`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#CouponCodeQueries"
            }}><inlineCode parentName="a">{`CouponCodeQueries`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`GraphQL queries for a cart's coupon code.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{` `}<em parentName="p">{`(Importing into your project)`}</em>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { useCouponCode } from '@magento/peregrine/lib/talons/CartPage/PriceAdjustments/CouponCode/useCouponCode';
`}</code></pre>
    <p>{`Contains logic for a shipping form component.
It performs effects and returns props data related to rendering a shipping address form.`}</p>
    <p>{`This talon performs the following effects:`}</p>
    <ul>
      <li parentName="ul">{`Manage the updating state of the cart while the mutation for setting the shipping address is in flight`}</li>
    </ul>
    <p><strong parentName="p">{`Returns:`}</strong>{`
`}<strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`props`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`props.selectedValues`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#SelectShippingFields"
            }}><inlineCode parentName="a">{`SelectShippingFields`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The values from the select input fields in the shipping form`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`props.setIsCartUpdating`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Callback function for setting the update state for the cart.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`props.mutations`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#ShippingFormMutations"
            }}><inlineCode parentName="a">{`ShippingFormMutations`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`GraphQL mutations for the shipping form.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`props.queries`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#ShippingFormQueries"
            }}><inlineCode parentName="a">{`ShippingFormQueries`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`GraphQL queries for the shipping form.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{` `}<em parentName="p">{`(Importing into your project)`}</em>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { useShippingForm } from '@magento/peregrine/lib/talons/CartPage/PriceAdjustments/ShippingMethods/useShippingForm';
`}</code></pre>
    <p>{`Contains logic for a shipping method selector component.
It performs effect and returns props data used to render that component.`}</p>
    <p>{`This talon performs the following effects:`}</p>
    <ul>
      <li parentName="ul">{`Set the shipping form visibility value based on the shipping methods associated with the cart`}</li>
    </ul>
    <p><strong parentName="p">{`Returns:`}</strong>{`
`}<strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`props`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`props.queries`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#ShippingMethodsQueries"
            }}><inlineCode parentName="a">{`ShippingMethodsQueries`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`GraphQL queries for shipping methods`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{` `}<em parentName="p">{`(Importing into your project)`}</em>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { useShippingMethods } from '@magento/peregrine/lib/talons/CartPage/PriceAdjustments/ShippingMethods/useShippingMethods';
`}</code></pre>
    <p>{`Contains logic for a component that renders a radio selector for shipping.
It performs effects and returns props data used for rendering that component.`}</p>
    <p>{`This talon performs the following effects:`}</p>
    <ul>
      <li parentName="ul">{`Sets the value of the shipping method to a default value if there is no current method selected`}</li>
      <li parentName="ul">{`Manage the updating state of the cart while a shipping method is being applied`}</li>
    </ul>
    <p><strong parentName="p">{`Returns:`}</strong>{`
`}<strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`props`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`props.setIsCartUpdating`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Function for setting the updating state of the shopping cart`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`props.selectedShippingMethod`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`String`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A serialized string of `}<inlineCode>{`\${carrier-code}`}{`|`}{`\${method-code}`}</inlineCode>{`, eg. `}<inlineCode>{`usps`}{`|`}{`priority`}</inlineCode>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`props.shippingMethods`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Array.<Object>`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`An array of available shipping methods`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`props.mutations`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#ShippingRadiosMutations"
            }}><inlineCode parentName="a">{`ShippingRadiosMutations`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`GraphQL mutations for a shipping radio selector component.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{` `}<em parentName="p">{`(Importing into your project)`}</em>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { useShippingRadios } from '@magento/peregrine/lib/talons/CartPage/PriceAdjustments/ShippingMethods/useShippingRadios';
`}</code></pre>
    <p>{`GraphQL mutations for a cart's coupon code.
This is a type used by the `}<a parentName="p" {...{
        "href": "#useCouponCode"
      }}>{`useCouponCode`}</a>{` talon.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://github.com/magento/pwa-studio/blob/develop/packages/venia-ui/lib/components/CartPage/PriceAdjustments/CouponCode/couponCode.js"
      }}>{`CouponCode.js`}</a>{`
for the queries used Venia`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Properties`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`applyCouponMutation`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`GraphQLAST`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Mutation for applying a coupon code to a cart.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`removeCouponMutation`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`GraphQLAST`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Mutation for removing a coupon code from a cart.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`GraphQL queries for a cart's coupon code.
This is a type used by the `}<a parentName="p" {...{
        "href": "#useCouponCode"
      }}>{`useCouponCode`}</a>{` talon.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://github.com/magento/pwa-studio/blob/develop/packages/venia-ui/lib/components/CartPage/PriceAdjustments/CouponCode/couponCode.js"
      }}>{`CouponCode.js`}</a>{`
for the queries used Venia`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Properties`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`getAppliedCouponsQuery`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`GraphQLAST`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Query to fetch the currently applied coupons for a cart.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Object type returned by the `}<a parentName="p" {...{
        "href": "#useCouponCode"
      }}>{`useCouponCode`}</a>{` talon.
It provides props data to use when rendering a coupon code component.`}</p>
    <p><strong parentName="p">{`Properties`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`applyingCoupon`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`True if a coupon is currently being applied. False otherwise.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`data`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Data returned from the `}<inlineCode parentName="td">{`getAppliedCouponsQuery`}</inlineCode>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`errorMessage`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`String`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`If GraphQL error occurs, this value is set.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`fetchError`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The error data object returned by a GraphQL query.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`handleApplyCoupon`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Function to call for handling the application of a coupon code to a cart.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`handleApplyCouponOnEnter`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Function to call for handling the application of a coupon code to a cart on enter key Press.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`handleRemoveCoupon`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Function to call for handling the removal of a coupon code from a cart`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`handleRemoveCouponOnEnter`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Function to call for handling the removal of a coupon code from a cart on enter key press.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`removingCoupon`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`True if a coupon code is currently being removed. False otherwise.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Values for the select input fields on the shipping form.
This is a prop used by the `}<a parentName="p" {...{
        "href": "#useShippingForm"
      }}>{`useShippingForm`}</a>{` talon.`}</p>
    <p><strong parentName="p">{`Properties`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`country`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`String`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Country shipping destination`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`region`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`String`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Country's region shipping destination`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`zip`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`String`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Country's zip code shipping destination`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`GraphQL mutations for the shipping form.
This is a type used by the `}<a parentName="p" {...{
        "href": "#useShippingForm"
      }}>{`useShippingForm`}</a>{` talon.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://github.com/magento/pwa-studio/blob/develop/packages/venia-ui/lib/components/CartPage/PriceAdjustments/ShippingMethods/shippingForm.js"
      }}>{`shippingForm.js`}</a>{`
for the query used in Venia`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Properties`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`setShippingAddressMutation`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`GraphQLAST`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Mutation for setting the shipping address on a cart`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`GraphQL queries for the shipping form.
This is a type used by the `}<a parentName="p" {...{
        "href": "#useShippingForm"
      }}>{`useShippingForm`}</a>{` talon.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://github.com/magento/pwa-studio/blob/develop/packages/venia-ui/lib/components/CartPage/PriceAdjustments/ShippingMethods/shippingMethods.gql.js"
      }}>{`shippingMethods.gql.js`}</a>{`
for the query used in Venia`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Properties`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`shippingMethodsQuery`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`GraphQLAST`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Query for getting data about available shipping methods`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Object type returned by the `}<a parentName="p" {...{
        "href": "#useShippingForm"
      }}>{`useShippingForm`}</a>{` talon.
It provides props data to use when rendering a shipping form component.`}</p>
    <p><strong parentName="p">{`Properties`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`formErrors`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Array.<Error>`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A list of form errors`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`handleOnSubmit`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Callback function to handle form submissions`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`handleOnSubmitKeyPress`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Callback function to handle form submissions on enter key`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`handleZipChange`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Callback function to handle a zip code change`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`isSetShippingLoading`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`True if the cart shipping information is being set. False otherwise.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`GraphQL queries for shipping methods.
This is a type used in the `}<a parentName="p" {...{
        "href": "#useShippingMethods"
      }}>{`useShippingMethods`}</a>{` talon.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://github.com/magento/pwa-studio/blob/develop/packages/venia-ui/lib/components/CartPage/PriceAdjustments/ShippingMethods/shippingMethods.gql.js"
      }}>{`shippingMethods.gql.js`}</a>{`
for the queries used in Venia`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Properties`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`getShippingMethodsQuery`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`GraphQLAST`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Query to get the available shipping methods.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Object type returned by the `}<a parentName="p" {...{
        "href": "#useShippingMethods"
      }}>{`useShippingMethods`}</a>{` talon.
It provides prop data to use when rendering shipping methods.`}</p>
    <p><strong parentName="p">{`Properties`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`hasMethods`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Provides the number of shipping methods available. Can be used as a boolean value since having no shipping methods would return 0.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`isShowingForm`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`True if the form should be shown. False otherwise.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`selectedShippingFields`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#SelectShippingFields"
            }}><inlineCode parentName="a">{`SelectShippingFields`}</inlineCode></a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Values for the select input fields on the shipping form`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`selectedShippingMethod`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`String`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A serialized string of `}<inlineCode>{`\${carrier-code}`}{`|`}{`\${method-code}`}</inlineCode>{`, eg. `}<inlineCode>{`usps`}{`|`}{`priority`}</inlineCode>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`shippingMethods`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Array.<Object>`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A list of available shipping methods based on the primary shipping address`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`showForm`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A function that sets the `}<inlineCode parentName="td">{`isShowingForm`}</inlineCode>{` value to true.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`showFormOnEnter`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A function that sets the `}<inlineCode parentName="td">{`isShowingForm`}</inlineCode>{` value to true.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`GraphQL mutations for a shipping radio selector component.
This is a type used by the `}<a parentName="p" {...{
        "href": "#useShippingRadios"
      }}>{`useShippingRadios`}</a>{` talon.`}</p>
    <p><strong parentName="p">{`Properties`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`setShippingMethodMutation`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`GraphQLAST`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Mutation for setting the shipping method on a cart.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Object type returned by the `}<a parentName="p" {...{
        "href": "#useShippingRadios"
      }}>{`useShippingRadios`}</a>{` talon.
It provides data to use when rendering a radio selector for shipping methods.`}</p>
    <p><strong parentName="p">{`Properties`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`formattedShippingMethods`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Shipping method data that has been formatted.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`handleShippingSelection`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Callback function for handling shipping selection form updates.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Source Code`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://github.com/magento/pwa-studio/blob/develop/packages/peregrine/lib/talons/CartPage/PriceAdjustments/CouponCode/useCouponCode.js"
      }}>{`pwa-studio/packages/peregrine/lib/talons/CartPage/PriceAdjustments/CouponCode/useCouponCode.js`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      